export default {
    version: '2.4.0',
    http_header: [],
    // 此参数用来设置 this.$API[xxx]().then()  异步请求返回的参数,
    // 此值为 true 则 只返回body中的数据 , 此值 为false 则返回所有的数据
    axios_response_body: true
}



// WEBPACK FOOTER //
// ./src/config/app.js